import React, { useEffect } from 'react';
import { I18nManager, Image, LogBox, StatusBar } from 'react-native';
import ImmersiveMode from 'react-native-immersive-mode';
import Toast from "react-native-toast-notifications";
import { Provider } from 'react-redux';
import '../icons';
import { GameWrapper } from './components/GameWrapper';
import { loadAndSetPersistentFile } from './shell/utils/appManagementFunctions';
import { isMobile } from './shell/utils/platformCheck';
import { store } from './store/store';
import { parseRequire } from './utils/parseImageUrl';
import "../src/shell/utils/devTools";
import "./utils/myConsole";
import "./utils/ErrorBoundary";
import { ErrorBoundary } from './utils/ErrorBoundary';

LogBox.ignoreLogs(["EventEmitter.removeListener('change', ...): Method has been deprecated. Please instead use `remove()` on the subscription returned by `EventEmitter.addListener`.", new RegExp("Require cycles are allowed")]);
// LogBox.ignoreAllLogs(true);

export const App = () => {
    useEffect(() => {
        I18nManager.allowRTL(false);
        loadAndSetPersistentFile();
        if (isMobile()) {
            StatusBar.setHidden(true);
            ImmersiveMode.fullLayout(true);
            ImmersiveMode.setBarMode("BottomSticky");
            const listen = ImmersiveMode.addEventListener((e) => {
                StatusBar.setHidden(true);
                ImmersiveMode.fullLayout(true);
                ImmersiveMode.setBarMode("BottomSticky");
            });
        }



    }, []);

    return (
        <Provider store={store}>
            {/* <PersistGate loading={null} persistor={persistor}> */}
            <ErrorBoundary>
                <GameWrapper></GameWrapper>
            </ErrorBoundary>
            <Toast
                placement="top"
                duration={5000}
                animationType='zoom-in'
                animationDuration={250}
                successColor="green"
                dangerColor="red"
                warningColor="orange"
                normalColor="lightblue"
                textStyle={{ fontSize: 20 }}
                offset={50}
                offsetTop={30}
                offsetBottom={40}
                swipeEnabled={true}
                ref={(ref) => global.toast = ref} />
            {/* </PersistGate> */}
        </Provider>
    );
};


export default App;